/**
 * @generated SignedSource<<cdd2dab7d9f58d3960b22eb8623d316d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobExamByCandidateApplicationQuery$variables = {
  candidateApplicationId: string;
  jobExamId: string;
};
export type JobExamByCandidateApplicationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JobExamByCandidateApplication_query">;
};
export type JobExamByCandidateApplicationQuery = {
  response: JobExamByCandidateApplicationQuery$data;
  variables: JobExamByCandidateApplicationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "candidateApplicationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jobExamId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobExamByCandidateApplicationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "candidateApplicationId",
            "variableName": "candidateApplicationId"
          },
          {
            "kind": "Variable",
            "name": "jobExamId",
            "variableName": "jobExamId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "JobExamByCandidateApplication_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JobExamByCandidateApplicationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": "jobExam",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "jobExamId"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "approvedMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasApplied",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reprovedMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuestionWeight",
                "kind": "LinkedField",
                "name": "questionsWeight",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobExamQuestion",
                    "kind": "LinkedField",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobExamQuestionOption",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weight",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "JobExam",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "candidateApplication",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "candidateApplicationId"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Candidate",
                "kind": "LinkedField",
                "name": "candidate",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "type": "CandidateApplication",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d8262809347c05c5d7e745ba14c26f8",
    "id": null,
    "metadata": {},
    "name": "JobExamByCandidateApplicationQuery",
    "operationKind": "query",
    "text": "query JobExamByCandidateApplicationQuery(\n  $jobExamId: ID!\n  $candidateApplicationId: ID!\n) {\n  ...JobExamByCandidateApplication_query_1WHBO4\n}\n\nfragment JobExamByCandidateApplication_query_1WHBO4 on Query {\n  me {\n    id\n  }\n  jobExam: node(id: $jobExamId) {\n    __typename\n    id\n    ... on JobExam {\n      id\n      title\n      approvedMessage\n      hasApplied\n      reprovedMessage\n      timeLimit\n      questionsWeight {\n        question {\n          id\n          title\n          type\n          options {\n            value\n          }\n        }\n        weight\n      }\n    }\n  }\n  candidateApplication: node(id: $candidateApplicationId) {\n    __typename\n    id\n    ... on CandidateApplication {\n      candidate {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0dce02ad081393deccda0a98215c9263";

export default node;
